module.exports = __webpack_public_path__ + "assets/79490dea53d297d0c05f342b7b6e361c.jpg";